import { Component, OnInit } from '@angular/core';
import {UntypedFormBuilder} from '@angular/forms';
import {Router} from '@angular/router';
import {QueryService} from '../../Services/query.service';
import {AppComponent} from '../../app.component';
import {ClientRequest} from '../../Interfaces/ClientRequest';
import {Subscription} from 'rxjs';
import {SSLView} from '../../Interfaces/SSLView';
import {TruckingCompanyView} from '../../Interfaces/TruckingCompanyView';
import {UtcsView} from '../../Interfaces/UtcsView';
import {User} from '../../Interfaces/User';
import {SharedVarService} from '../shared-service.service';
import {GlobalEventsManager} from '../../GlobalEventManager';

@Component({
  selector: 'app-utcs-inquiry',
  templateUrl: './utcs-inquiry.component.html',
  styleUrls: ['./utcs-inquiry.component.css']
})
export class UtcsInquiryComponent implements OnInit {
  public sslLine: string;
  public truckingCo: string;
  public utcsDetail: UtcsView;
  public utcsArray: UtcsView[] = [];
  public ssls : SSLView[] = [];
  public truckers : TruckingCompanyView[] = [];
  private clientRequest: ClientRequest;
  public submitted: boolean = false;
  public noDataFound: boolean = false;

  private subscription: Subscription;
  private options: Intl.DateTimeFormatOptions = {month: "2-digit", day: "2-digit", year: "numeric", hour: "numeric",minute:"numeric",second:"numeric"};
  private  date1: Date;
  public  myUser: User;




  constructor(fb: UntypedFormBuilder,  private router: Router, private  queryService: QueryService, private  globalEventsManager: GlobalEventsManager,public myApp:AppComponent, private service: SharedVarService) {
    this.myUser = this.myApp.user;

/*
        this.myUser = {} as User;
        this.myUser.active ="Y"
        this.myUser.address_1 = "15600 JFK BLVD. Suite 400"
        this.myUser.address_2 = null
        this.myUser.company_code ="M0995"
        this.myUser.company_name= "MAHER TERMINALS, LLC"
        this.myUser.city= "HOUSTON"
        this.myUser.company_name= "COSCO"
        this.myUser.email_address= null
        this.myUser.fax_number= null
        this.myUser.first_name= "Csp Craig"
        this.myUser.last_name= "Miller"
        this.myUser. maherError= null
        this.myUser.old_password= null
        this.myUser.password= ""
        this.myUser.phone_number= null
        this.myUser.company_scac= null
        this.myUser.state= "TX"
        this.myUser.userMenuReportItemsView= null
        this.myUser.user_gkey= "8237887"
    //    this.myUser.user_role= "AGENT"
        this.myUser.role= "HAULIER"
        this.myUser.username="MAHERTRUCKER"
        this.myUser.zip="07201"
        this.myUser.canSeeAllData = "0";


 */


  }

  ngOnInit() {

    this.ssls = [];
    this.truckers = [];

    this.fillSSLs();
    this.utcsDetail = {} as UtcsView;

  }


  public getUtcsRecord(){
    this.submitted = true;
    this.noDataFound = false;
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];
    var lhsUserObs$;
    if (this.myUser.canSeeAllData=="1"){
      this.utcsDetail.truckerid = this.truckingCo;
      this.utcsDetail.shippingline = this.sslLine;
      this.clientRequest.requestData[0] = this.utcsDetail;
      lhsUserObs$ = this.queryService.utcsBySslAndTruckerCode(this.clientRequest);
    }else if (this.myUser.role=="HAULIER") {
      this.utcsDetail.shippingline = this.sslLine;
      this.clientRequest.requestData[0] = this.utcsDetail;
      lhsUserObs$ = this.queryService.utcsBySslAndUser(this.clientRequest);
    }

    this.subscription = lhsUserObs$.subscribe(
      (utcs) => {
        this.utcsArray = utcs;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
        if (this.utcsArray[0].maherError != null) {
            this.utcsDetail = {} as UtcsView;
            this.formatDetailScreen()
            this.noDataFound = true;

        }else if (this.utcsArray[0].navisErrors!=null){
            this.utcsDetail = {} as UtcsView;
            this.formatDetailScreen()
            this.noDataFound = true;
        }else{
            this.submitted = false;
            this.utcsDetail = this.utcsArray[0];
            this.formatDetailScreen();
        }

      });
  }


  private fillSSLs(){
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];
    const lhsUserObs$ = this.queryService.getAllSsls(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (ssls) => {
        this.ssls = ssls;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
        if (this.ssls[0].maherError != null) {

        }else if (this.ssls[0].navisErrors!=null){

        }else{
          this.sslLine = this.ssls[0].code;
          this.fillTruckers();

        }

      });
  }

  private fillTruckers(){
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];
    const lhsUserObs$ = this.queryService.getAllTruckingCompanies(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (trks) => {
        this.truckers = trks;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
        if (this.truckers[0].maherError != null) {

        }else if (this.truckers[0].navisErrors!=null){

        }else{
          this.truckingCo = this.truckers[0].id;
          this.getUtcsRecord();

        }

      });
  }

  getNiceDateTime(dateIn: string): string {
    this.date1 =  new Date(dateIn);
    return this.date1.toLocaleDateString("en-US", this.options);
  }

  formatDetailScreen() {
    if (this.utcsDetail.shippinglinename == null) {
      this.utcsDetail.shippinglinename = " ";
    }
    if (this.utcsDetail.truckername == null) {
      this.utcsDetail.truckername = " ";
    }
    if (this.utcsDetail.trucklinestatus == null) {
      this.utcsDetail.trucklinestatus = " ";
    }
    if (this.utcsDetail.lifecyclestatedescription == null) {
      this.utcsDetail.lifecyclestatedescription = " ";
    }
    if (this.utcsDetail.createdby == null) {
      this.utcsDetail.createdby = " ";
    }
    if (this.utcsDetail.modifiedby == null) {
      this.utcsDetail.modifiedby = " ";
    }
    if (this.utcsDetail.insuranceexpirationdate_fmt == null) {
      this.utcsDetail.insuranceexpirationdate_fmt = " ";
    } else {
      this.utcsDetail.insuranceexpirationdate_fmt = this.utcsDetail.insuranceexpirationdate_fmt.substr(0,this.utcsDetail.insuranceexpirationdate_fmt.indexOf(" "));
    }
    if (this.utcsDetail.creditexpirationdate_fmt == null) {
      this.utcsDetail.creditexpirationdate_fmt = " ";
    } else {
      this.utcsDetail.creditexpirationdate_fmt = this.utcsDetail.creditexpirationdate_fmt.substr(0,this.utcsDetail.creditexpirationdate_fmt.indexOf(" "));
    }
    if (this.utcsDetail.expirationdate_fmt == null) {
      this.utcsDetail.expirationdate_fmt = " ";
    } else {
      this.utcsDetail.expirationdate_fmt = this.utcsDetail.expirationdate_fmt.substr(0,this.utcsDetail.expirationdate_fmt.indexOf(" "));
    }
    if (this.utcsDetail.createddate_fmt == null) {
      this.utcsDetail.createddate_fmt = " ";
    }
    if (this.utcsDetail.modifieddate_fmt == null) {
      this.utcsDetail.modifieddate_fmt = " ";
    }
  }

}
